import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getSkinId, setBodyOverflow } from 'src/helpers/utils';
import { useConnectedAction } from 'src/hooks/use-connected-action';
import { useI18n } from 'src/hooks/use-i18n-translation';
import useKycPopup from 'src/hooks/use-kycPopup';
import { gameUrlRequest } from 'src/services/gameApi';
import { openDialog } from 'src/store/dialog/actions';
import { RootState } from 'src/types/store-types';

const FirstSportbook: FC = () => {
  const { locale } = useI18n();
  const { categoriesData } = useSelector((state: RootState) => state.configs);
  const { user, kycStatus } = useSelector((state: RootState) => state.user);
  const { section } = useSelector((state: RootState) => state.accountModal);
  const _openDialog = useConnectedAction(openDialog);
  const [data, setData] = useState<any>(null);
  const { i18n } = useTranslation();

  // Fetch game URL data.
  const getSportGame = useCallback(async (): Promise<void> => {
    const game = categoriesData?.betting?.tags[0]?.tagGames.find((tag) => tag.name === 'first');
    if (game) {
      const payload: any = {
        id: game.id,
        skinId: getSkinId(),
        lang: locale,
        device: isMobile ? 'mobile' : 'desktop',
      };

      if (user) {
        payload.userId = user.id;
        payload.token = user.token;
      }

      const res: any = await gameUrlRequest(payload);
      if (res.result) {
        setData(res.result.data);
      } else {
        console.log(`get game url error ${game.id}`);
      }
    }
  }, [locale, categoriesData, isMobile, user]);

  const computedUrl = useMemo(() => {
    if (!data?.url) return '';
    const lang = i18n.language === 'pt' ? 'br-pt' : i18n.language;
    const url = new URL(data?.url);
    const urlSearch = new URLSearchParams(url.search);
    urlSearch.append('api', `${location.origin}/whl.js`);
    return `${url.origin}/${lang}/?${urlSearch.toString()}`;
  }, [data?.url, i18n.language]);

  useEffect(() => {
    getSportGame();
  }, [getSportGame]);

  useEffect(() => {
    data && setBodyOverflow('unset', true);

    return () => {
      setBodyOverflow('set', true);
    };
  }, [data]);

  useKycPopup(kycStatus, user, section, _openDialog);

  if (!computedUrl) return null;

  return <iframe id="firstSportbook" src={computedUrl} />;
};

export default FirstSportbook;
